import React, {useContext, useEffect} from 'react';
import {Accordion, Loader, RowData} from '../../../../components';
import Layout from './Layout';
import {PageContext} from '../../../../helpers/context';
import {useEventDetails} from '../hooks/useEventsDetails';

function EvaluationResult() {
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('easydetect');
  }, [setPageName]);

  const {isLoading, RANGES_USED, TRIGGERED_RULES} = useEventDetails();
  console.log(TRIGGERED_RULES, '>>>');

  return (
    <Layout>
      <div className=" xl:ml-4 xl:basis-[43.91%] mt-6 xl:mt-0 px-4 grow xl:grow-0 xl:p-8 pt-4 xl:pt-[36px] bg-white80 xl:bg-white">
        {isLoading ? (
          <Loader height={40} />
        ) : (
          <div className="flex flex-col gap-3 bg-brandBlueLight rounded">
            {RANGES_USED.length > 0 && (
              <Accordion
                customTitle={
                  <h2 className="font-medium w-full ">Ranges Used</h2>
                }
                noChildPadding
                customPadding=""
                customClasses="bg-transparent p-3 pb-3"
                background="bg-white4"
                isOpen={false}
              >
                {RANGES_USED.map(data => (
                  <RowData
                    key={data.leftText}
                    leftText={data.leftText}
                    rightText={data.rightText}
                  />
                ))}
              </Accordion>
            )}
            {TRIGGERED_RULES.length > 0 && (
              <Accordion
                customTitle={
                  <h2 className="font-medium w-full ">Triggered Rules</h2>
                }
                noChildPadding
                customPadding=""
                customClasses="bg-transparent p-3 pb-3"
                background="bg-white4"
                isOpen={false}
              >
                {TRIGGERED_RULES.map((data, index) => (
                  <RowData
                    key={index}
                    leftCustomUI={
                      <div className="flex flex-col gap-1 ">
                        <div className="flex flex-col gap-1 ">
                          <p className="text-xs font-medium uppercase text-grey">
                            Rule Name
                          </p>
                          <p className="text-xs text-grey">{data?.message}</p>
                        </div>
                        <div className="flex flex-col gap-1 mt-3">
                          <p className="text-xs font-medium uppercase text-grey">
                            Description
                          </p>
                          <p className="text-xs text-grey">
                            {data?.description || 'N/A'}
                          </p>
                        </div>
                      </div>
                    }
                    customUI={
                      <div className="flex flex-col gap-1 justify-start">
                        <p className="text-xs font-medium uppercase text-grey">
                          Score
                        </p>
                        <p className="text-sm font-medium text-grey">
                          {data?.score}
                        </p>
                      </div>
                    }
                  />
                ))}
              </Accordion>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default EvaluationResult;
